import React, { useEffect, useRef, useState } from 'react'
import FlatList from './FlatList'
interface Props {
  data: any[]
  component: React.FC<any>
  fetchMore: () => Promise<void>
  itemsPerRow: number
  filters?: any
}

const GridFlatList = ({ data, component, fetchMore, itemsPerRow, filters }: Props): JSX.Element => {
  const [itemWidth, setItemWidth] = useState<number>(300)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current !== null) {
      setItemWidth(ref.current.clientWidth / itemsPerRow)
    }
  }, [itemsPerRow])

  return (
    <div className="h-full" ref={ref}>
      <FlatList
        data={data}
        component={component}
        fetchMore={fetchMore}
        itemMinWidth={`${itemWidth}px`}
        filters={filters}
      />
    </div>
  )
}

export default GridFlatList
